import { useCallback } from 'react';

import addMonths from 'date-fns/addMonths';
import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import startOfDay from 'date-fns/startOfDay';
import type { FormikProps } from 'formik';
import { Formik } from 'formik';
import { parseDdMmYyyy } from 'v2/formatters/date';
import type { EFinancialStatementTabs, FinancialStatementFilter } from 'v2/interfaces/financial';
import { SearchType } from 'v2/interfaces/financial';
import { initialFilter } from 'v2/services/financialStatement/statement';
import * as Yup from 'yup';

import Form from './Form';

interface IFilterProps {
  currentTab: EFinancialStatementTabs;
}

const isValidDateRange = (value?: string[]) => {
  if (!value?.[0] || !value?.[1]) return false;

  const start = startOfDay(parseDdMmYyyy(value[0]));
  const end = startOfDay(parseDdMmYyyy(value[1]));
  const today = startOfDay(new Date());

  if (isBefore(end, start)) return false;
  if (isAfter(start, today) || isAfter(end, today)) return false;

  return !isAfter(end, startOfDay(addMonths(start, 6)));
};

const formValidation = Yup.object().shape({
  search_text: Yup.string()
    .when('search_type', {
      is: SearchType.EMAIL,
      then: Yup.string().email('E-mail inválido')
    })
    .when('search_type', {
      is: SearchType.DOCUMENT,
      then: Yup.string().test('length', 'CPF/CNPJ inválido', (val = '') => val.length === 11 || val.length === 14)
    }),
  dates: Yup.mixed().test('period', 'Período máximo 6 meses', (value: string[]) => isValidDateRange(value))
});

function Filter({ currentTab }: IFilterProps) {
  const onSubmit = useCallback(
    (values: FinancialStatementFilter, { setSubmitting }: FormikProps<FinancialStatementFilter>) => {
      setSubmitting(false);
    },
    []
  );

  return (
    <Formik initialValues={initialFilter} onSubmit={onSubmit} validationSchema={formValidation}>
      {props => <Form {...props} currentTab={currentTab} />}
    </Formik>
  );
}

export default Filter;
